import React, {useState} from "react";
import {Brands} from "./internal";

const fontTrackers: {[Brand in Brands]?: string} = {
  [Brands.Athleta]:
    "https://fast.fonts.net/t/1.css?apiType=css&projectid=41bf3387-8a4a-46a5-9607-6554d760b7ae",
  [Brands.BananaRepublic]:
    "https://fast.fonts.net/t/1.css?apiType=css&projectid=0e5ae342-8d48-4e7a-9491-e82fee9dcc17",
};

export function FontTracker({brand}: {brand: Brands}): JSX.Element | null {
  const [isLoaded, setIsLoaded] = useState(false);
  const fontTracker = fontTrackers[brand];
  return fontTracker ? (
    <link
      data-testid="font-tracker"
      href={fontTracker}
      media={isLoaded ? "all" : "print"}
      onLoad={() => setIsLoaded(true)}
      rel="stylesheet"
    />
  ) : null;
}
